import { axiosInstance } from "@/api/index";
import { ApiResponse } from "@/api/types";

export const getRestrictedHelpCenterJwt = async () => {
  return await axiosInstance.get<ApiResponse.ZendeskRestrictedHelpCenterJwt>(
    `/api/cloud/zendesk/v1/restricted_help_center_jwt`
  );
};
